<script setup>
import {defineProps} from "vue";

//==================================================================//
//========================= Props / Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
]);

//==================================================================//
//========================= Dados Headers ===========================//
//==================================================================//

let dadosHeaders = [
    { text: '',                   value: 'visualizar'},
    { text: 'N° da Parcela',      value: 'codigo'},
    { text: 'Sequência',          value: 'sequencia'},
    { text: 'Tipo',               value: 'tipo'},
    { text: 'Descrição',          value: 'descricao'},
    { text: 'Dias',               value: 'parcelaDias'},
    { text: 'Data Vencimento',    value: 'dataVencimentoFormatada'},
    { text: 'Data Previsão',      value: 'dataPrevisaoFormatada'},
    { text: 'Percentual',         value: 'parcelaPorcentagem'},
    { text: 'Valor Original',     value: 'valorOriginal'},
    { text: 'Valor Liquidado',    value: 'valorRecebido'},
    { text: 'Valor a Liquidar',   value: 'valorParaReceber'},
    { text: '',                   value: 'espaco'},
]

</script>

<template>

    <div class="c-table__header">

        <div class="c-header__cell" v-for="dadoHeader in dadosHeaders"
            :key="dadoHeader.value"
        >

            <div class="c-cell c-cell__text">

                {{dadoHeader.text}}

            </div>
            
        </div>

    </div>

</template>

<style scoped>

.c-table__header{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
    color: rgba(0, 0, 0, 0.6);
    font-size: 0.75rem;
}

.c-header__cell{
    align-content: center;
    padding: 14px 16px;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    font-weight: 700;
    background-color: #230bc1;
    color: #ffffff;
}

</style>